import { m } from "framer-motion"
import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const ItemWrapper = styled.div`
  .item {
    &-label {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
    }
    &-heading {
      p {
        margin-bottom: 0;
      }
      font-weight: 850;
      font-size: 24px;
      line-height: 32px;
      color: ${color.oxfordBlue[900]};
      padding: 16px;
      cursor: pointer;
      position: relative;
      display: grid;
      grid-template-columns: 1fr 12px;
      justify-content: space-between;
      gap: 16px;
      svg {
        margin: auto 0;
        width: 12px;
        transition: transform 150ms ease;
        path {
          stroke: ${color.primary[700]};
        }
      }
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      &:after {
        content: "";
        position: absolute;
        height: 1px;
        width: calc(100% - 32px);
        z-index: -1;
        left: 16px;
        bottom: 0;
        background-color: ${color.copy[200]};
      }
    }
    &-content {
      white-space: normal;
      overflow: hidden;
      padding: 0 16px 16px;
      font-weight: 350;
      font-size: 16px;
      line-height: 24px;
      color: ${color.copy[700]};
      background-color: ${color.aliceBlue[50]};
      height: fit-content;
      &-heading {
        margin-bottom: 0;
        font-size: 20px;
        line-height: 30px;
        font-weight: 800;
        padding: 16px 0;
        color: ${color.oxfordBlue[900]};
      }
    }
  }

  .image-wrapper {
    display: block;
    img {
      max-width: 100%;
    }
  }
  &.opened {
    .item {
      &-label {
        color: ${color.primary[900]};
      }
      &-heading {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
`
export const AccordionWrapper = styled.div`
  margin: 40px 0;
  .heading-container {
    padding: 0 16px;
    .heading {
      font-weight: 800 !important;
      font-size: 24px !important;
      line-height: 32px !important;
    }
    .description {
      * {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`

export const ItemContent = styled(m.div)``
